import { EventSerializer, PaymentSerializer, UserSerializer } from 'services/serializers';

export default class JobSerializer {
  static deserialize(job, athleticTrainers = []) {
    const result = {
      id: job.id,
      appliedDate: job.applied_date,
      currentState: job.current_state,
      endTime: job.end_time,
      shiftId: job.shift_id,
      startTime: job.start_time,
      userId: job.user_id,
      rateTypeId: job.rate_type_id,
      payRate: job.pay_rate,
      expiresAt: job.eo_expires_at,
      cancelledAt: job.cancelled_at,
      showCancellationPolicy: true,
      go4PlatformPaid: job.go4_platform_paid,
      lastPaymentAttemptAt: job.last_payment_attempt_at,
    };

    if (job.payment) {
      result['payment'] = PaymentSerializer.deserialize(job.payment);
    }

    if (job.user) {
      result['user'] = UserSerializer.deserializeHCT(job.user);
    } else if (job.user_id) {
      result['user'] = UserSerializer.deserializeHCT(athleticTrainers.find(at => at.id == job.user_id));
    }

    if (job.job_modification) {
      result['jobModification'] = JobSerializer.deserialize(job.job_modification);
    }

    if (job.cancellation) {
      result['cancellation'] = {
        cancelReason: job.cancellation.cancel_reason,
        amountInCents: job.cancellation.amount_in_cents,
        createdAt: job.cancellation.created_at,
        jobId: job.cancellation.job_id,
      };
    }

    if (job.event) {
      result['event'] = EventSerializer.deserialize(job.event);
    }

    return result;
  }

  static serialize(job) {
    const result = {
      id: job.id,
      applied_date: job.appliedDate,
      end_time: job.endTime,
      shift_id: job.shiftId,
      start_time: job.startTime,
      state: job.state,
      user_id: job.userId,
      rate_type_id: job.rateTypeId,
      pay_rate: job.payRate,
    };

    return result;
  }

  static bulkTransitionSerializer(params) {
    const result = {
      job_ids: params.jobIds,
      to_state: params.toState,
      from_state: params.fromState,
    };

    return result;
  }
}
